// Back easing gives a small pull against the destination, followed by a
// quick transfer, slight overshoot and a soft landing within 100 ms.
export function layerSwitchEase(progress: number): number {
  const t = Math.max(0, Math.min(1, progress));
  if (t === 0 || t === 1) return t;
  const back = 1.70158 * 1.525;
  if (t < 0.5) {
    const doubled = 2 * t;
    return doubled * doubled * ((back + 1) * doubled - back) / 2;
  }
  const doubled = 2 * t - 2;
  return (doubled * doubled * ((back + 1) * doubled + back) + 2) / 2;
}
